import { BgColorMap } from './constants';
export const getBgColor = (backgroundColor) => {
    return BgColorMap[backgroundColor] || backgroundColor;
};
export const getCtaBtnColor = (bgColor, ctaBtnColor) => {
    const background = getBgColor(bgColor);
    const allowedButtonTypes = {
        neutral100: ['primary', 'primary-alt', 'brand'],
        zapier: ['primary-alt'],
        night: ['primary-dark', 'brand'],
        moss: ['primary-dark', 'brand'],
        neutral800: ['primary-dark', 'brand'],
        earth: ['primary-dark', 'brand'],
    };
    if (ctaBtnColor && allowedButtonTypes[background].includes(ctaBtnColor)) {
        return ctaBtnColor;
    }
    return allowedButtonTypes[background][0];
};
//# sourceMappingURL=utils.js.map
// @zapier/design-system@6.27.0 (617a97f69)
